import {
  IWeeklyScheduleDay,
  IAvailabilityException,
  ICreateAvailabilityExceptionRequest,
  IUpdateAvailabilityExceptionRequest,
} from '../interfaces/heavyDutyMachinery/IAvailability';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

export const getServiceSchedule = async (serviceId: string): Promise<IWeeklyScheduleDay[]> => {
  const response = await apiService<IWeeklyScheduleDay[]>({
    url: API_ENDPOINTS.SERVICE_SCHEDULE(serviceId),
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load schedule');
};

export const updateServiceSchedule = async (
  serviceId: string,
  days: IWeeklyScheduleDay[]
): Promise<IWeeklyScheduleDay[]> => {
  const response = await apiService<IWeeklyScheduleDay[]>({
    url: API_ENDPOINTS.SERVICE_SCHEDULE(serviceId),
    method: HTTP_METHODS.PUT,
    body: { days },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to update schedule');
};

export const getServiceExceptions = async (
  serviceId: string,
  from?: string,
  to?: string
): Promise<IAvailabilityException[]> => {
  const params: Record<string, string> = {};
  if (from) params.from = from;
  if (to) params.to = to;
  const response = await apiService<IAvailabilityException[]>({
    url: API_ENDPOINTS.SERVICE_EXCEPTIONS(serviceId),
    method: HTTP_METHODS.GET,
    params,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load exceptions');
};

export const createServiceException = async (
  serviceId: string,
  request: ICreateAvailabilityExceptionRequest
): Promise<IAvailabilityException> => {
  const response = await apiService<IAvailabilityException>({
    url: API_ENDPOINTS.SERVICE_EXCEPTIONS(serviceId),
    method: HTTP_METHODS.POST,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to create exception');
};

export const updateServiceException = async (
  serviceId: string,
  exceptionId: string,
  request: IUpdateAvailabilityExceptionRequest
): Promise<IAvailabilityException> => {
  const response = await apiService<IAvailabilityException>({
    url: API_ENDPOINTS.SERVICE_EXCEPTION_BY_ID(serviceId, exceptionId),
    method: HTTP_METHODS.PUT,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to update exception');
};

export const deleteServiceException = async (serviceId: string, exceptionId: string): Promise<void> => {
  const response = await apiService<{ message: string }>({
    url: API_ENDPOINTS.SERVICE_EXCEPTION_BY_ID(serviceId, exceptionId),
    method: HTTP_METHODS.DELETE,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (!response.success) throw new Error(response.error || 'Failed to delete exception');
};
